import React from 'react';

import LogoutIcon from '@mui/icons-material/Logout';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import * as selectorsHeader from '../../selector';
import { signOut } from '../thunk';

/**
 * プロパティ
 */
export type Props = {
  /** クリック */
  onClick: () => void,
};

const SignoutItem: React.FC<Props> = ({ onClick }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectorsHeader.isLoadingSelector);
  return (
    <ListItem
      button
      disabled={isLoading}
      onClick={() => {
        if (isLoading) {
          return;
        }
        dispatch(signOut());
        onClick();
      }}
    >
      <ListItemIcon>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText primary="ログアウト" />
    </ListItem>
  );
};

export default SignoutItem;
